module.exports = __webpack_public_path__ + "img/icon.516778c6.svg";